var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataEnrichment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-enrichment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 0H9.375V1.25H10.625V0ZM14.8612 2.99805L15.7451 2.11417L16.629 2.99805L15.7451 3.88192L14.8612 2.99805ZM17.5 8.125H18.75V9.375H17.5V8.125ZM4.25475 3.89526L3.37088 3.01139L4.25475 2.12751L5.13863 3.01139L4.25475 3.89526ZM2.5 8.125H1.25V9.375H2.5V8.125ZM8.125 20V18.75H11.875V20H8.125ZM13.125 17.5V16.25H6.875V17.5H13.125ZM3.75 8.75C3.75 5.3125 6.5625 2.5 10 2.5C13.4375 2.5 16.25 5.3125 16.25 8.75C16.25 11.5 15 12.6875 14.0625 13.5C13.4375 14.0625 13.125 14.4375 13.125 15H11.875C11.875 13.8125 12.5625 13.1875 13.25 12.5625C14.125 11.8125 15 10.9375 15 8.75C15 6 12.75 3.75 10 3.75C7.25 3.75 5 6 5 8.75C5 10.9375 5.875 11.8125 6.75 12.5625C7.4375 13.1875 8.125 13.875 8.125 15H6.875C6.875 14.4375 6.5625 14.0625 5.9375 13.5C5 12.6875 3.75 11.5 3.75 8.75Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEnrichment);
export default __webpack_public_path__ + "static/media/data-enrichment.e1744d803e4f32763737a7255592977f.svg";
export { ForwardRef as ReactComponent };